import newFetch from '@/utils/newFetch';
import Api, { baseURL, requestOptionsGET, requestOptionsPOST } from '../api';

const reportTypes = {
  SENDER: 'Sender',
  ADMIN: 'Admin'
};

const getReportBody = (params) => {
  const body = {
    deliveryForecastDateStart: params.initialForecastDate,
    deliveryForecastDateEnd: params.endForecastDate,
    completionDateStart: params.initialCompletionDate,
    completionDateEnd: params.endCompletionDate,
    initialDate: params.initialDate,
    dateEnd: params.dateEnd,
    holidays: params.holidays,
    stateId: params.stateId,
    cityId: params.cityId,
    hasReceipt: params.hasReceiptFilter,
    receiptIsValid: params.isReceiptValidFilter,
    transferred: params.isTransferred,
    transhipmentId: params.transhipmentId,
    cteNumber: params.numberCTE.map((number) => parseInt(number)),
    senderName: params.sender,
    senderId: params.senderId,
    recipientName: params.recipient,
    nfeNumber: params.keyNfe.map((number) => parseInt(number)),
    boardingNumber: params.boardingNumber.map((number) => parseInt(number)),
    directDelivererId: params.courierId,
    numberInvoiceId: params.numberInvoiceId,
    boardingId: params.boardingId,
    statusIds: params.status
  };

  return body;
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  report(_, params) {
    const { filters, body, isShipper } = params;
    const payload = getReportBody({ ...filters, ...body });

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + `${Api.report}?type=${isShipper ? reportTypes.SENDER : reportTypes.ADMIN}`,
        requestOptionsPOST(localStorage.getItem('accessToken'), payload)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async downloadReport(_, id) {
    const base_url = baseURL + `${Api.downloadExport}/${id}/Download`;
    const obj = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken').toString(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Response-Type': 'APPLICATION/octet-stream'
      },
      method: 'GET'
    };

    await fetch(base_url, obj)
      .then((response) => {
        if (response.status === 200) {
          return response.blob();
        } else {
          return Promise.reject(response);
        }
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `RELATÓRIO-DE-NOTAS-FISCAIS-${id}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  },

  getReports(_, isShipper = false) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + `${Api.getReports}?type=${isShipper ? reportTypes.SENDER : reportTypes.ADMIN}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          data = data.map((item) => ({ ...item, holidays: JSON.parse(item.holidays) }));
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
